import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import {useFormik} from 'formik';
import {useContext} from 'react';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Field from '../../ui/form/Field';
import ExecutionsAPI from '../../../services/ExecutionsAPI';
import AuthContext from '../../../contexts/AuthContext';
import {useStoreExecutions} from '../../../store/useStoreExecutions';
import AlertCustom from '../../ui/alert/AlertCustom';

interface CommentFormInterface {
    order: object;
    setShowModal: Function;
    setModalContent: Function;
}
export const CommentForm = ({order, setShowModal, setModalContent}: CommentFormInterface) => {
    const {user} = useContext(AuthContext);
    const getExecutions = useStoreExecutions((state) => state.getExecutions);
    const formik = useFormik({
        initialValues: {
            comment: '',
        },
        onSubmit: (values) => {
            handleSubmit(values);
        }
    });

    async function handleSubmit(values) {
        try {
            await ExecutionsAPI.postExecutions({
                etatextranet: Number.parseInt(order.item.actions[order.id].id, 10),
                etatextranetlibelle: order.item.actions[order.id].label,
                idsgribouil: order.item.idsgribouil,
                numcde: order.item.numcde,
                motifdesc: values.comment,
            });

            getExecutions(user, true, false);
            setShowModal(false);
        } catch (error) {
            setModalContent(
                <AlertCustom
                    variant={'danger'}
                    heading={true}
                    bodyContent={error.response.data.detail}
                    transition={true}
                />,
            );
        }
    }

    return (
        <Col className={'text-left'}>
            <Form
                id={'commentForm'}
                onSubmit={(event) => {
                    event.preventDefault()
                    formik.handleSubmit()
                }}>
                <Field
                    as={'textarea'}
                    rows={8}
                    name={'comment'}
                    placeholder={'Ajouter un commentaire'}
                    fieldClassNames={'bg-white'}
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    style={{resize: 'none', 'border-color': 'lightgray'}}
                />
                <Row className={'d-flex justify-content-center mt-3'}>
                    <Col xs={6} className={'d-flex justify-content-between'}>
                        <Button type={'submit'}>Enregistrer</Button>
                        <Button type={'submit'}>Fermer</Button>
                    </Col>
                </Row>
            </Form>
        </Col>
    )
}
